import styled from '@emotion/styled';

const Empty = styled.div`
  width: 800px;
  height: 20px;
  padding-top: 5px;
  padding-left: 10px;
  margin: 50px auto 0;
`;

const StyledError = styled(Empty)`
  color: red;
  background-color: #ffffff;
  border-radius: 6px;
  opacity: 0.8;
  box-shadow: 1px 1px 2px #ccc;
`;

export function LoginError({ error }: { error: string | null }) {
  return error ? <StyledError>{error}</StyledError> : <Empty />;
}
